export default 'indicator'
